import React from "react";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { ButtonGrid } from "@sonder/ui/source/styled/fragments/ButtonGrid";
import {
  GetTaskCategoriesCategory,
  useGetTaskCategoriesQuery,
} from "core/queries/GetTaskCategories";
import { ButtonGridMultiContentLoader } from "tasks/components/ButtonGrid.loader";
import { TaskContextSubjectTypeEnum, TypeEnum } from "typings/globalGQLTypes";

interface TaskCategoriesProps {
  locationId?: string | null;
  onChange?: (category: GetTaskCategoriesCategory) => void;
  subjectType: TaskContextSubjectTypeEnum;
  taskType: TypeEnum | null;
  value: GetTaskCategoriesCategory | null;
}

export const TaskCategories = ({
  locationId,
  onChange,
  subjectType,
  taskType,
  value,
}: TaskCategoriesProps) => {
  const { loading, data, error } = useGetTaskCategoriesQuery({
    skip: !taskType || !locationId,
    variables: {
      filters: {
        taskTypes: taskType ? [taskType] : null,
        locationIds: locationId ? [locationId] : null,
        subjectTypes: subjectType ? [subjectType] : null,
      },
    },
  });

  if (!locationId || !taskType) {
    return null;
  }

  return (
    <>
      {loading && <ButtonGridMultiContentLoader />}
      {error && error.message && `There was an error: ${error.message}.`}
      {data?.taskCategories && (
        <ButtonGrid>
          {data?.taskCategories.map(category => (
            <Button
              key={category.id}
              selected={value?.id === category.id}
              onClick={() => {
                if (onChange) {
                  onChange(category);
                }
              }}
            >
              {category.name}
            </Button>
          ))}
        </ButtonGrid>
      )}
    </>
  );
};
